import { Typography } from '@compass/components'

import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const label = 'requestID' // visitFilterLabelMap[key] // conforming the existing analytics label

export const requestIdColumn = columnHelper.display({
  id: 'requestId',
  header: 'Event ID',
  enableHiding: false,
  meta: { isRowHeader: true },
  cell: ({ row }) => {
    const requestId = row.original.event_id

    if (!requestId) {
      return <Unavailable />
    }

    return (
      <CellAction copyValue={requestId} field={label}>
        <Typography className='font-mono'>{requestId}</Typography>
      </CellAction>
    )
  },
})
